import { createReducer } from 'redux-create-reducer'
import type {
  ClientLibraryDiscoveryPanelItem,
  ClientLibraryId,
} from 'types/client-library'
import {
  CLIENT_LIBRARY_DISCOVERY_PANEL_RECENT_LOAD,
  CLIENT_LIBRARY_DISCOVERY_PANEL_RECENT_LOAD_FAIL,
  CLIENT_LIBRARY_DISCOVERY_PANEL_RECENT_LOAD_SUCCESS,
} from '@disco/constants/ActionTypes'
export type State = {
  error: Error | null | undefined
  loading: boolean
  loaded: boolean
  items: Record<ClientLibraryId, ClientLibraryDiscoveryPanelItem>
  list: ClientLibraryId[]
}
const initialState: State = {
  error: null,
  loading: false,
  loaded: false,
  items: {},
  list: [],
}
export const discoveryPanelRecentReducer = createReducer<State, any>(
  initialState,
  {
    [CLIENT_LIBRARY_DISCOVERY_PANEL_RECENT_LOAD](state: State) {
      return { ...state, error: null, loading: true, list: [] }
    },

    [CLIENT_LIBRARY_DISCOVERY_PANEL_RECENT_LOAD_SUCCESS](
      state: State,
      { response }: Record<string, any>,
    ) {
      const items = {}
      response.results.forEach(library => {
        items[library.id] = { ...library }
      })
      return {
        ...state,
        error: null,
        loaded: true,
        loading: false,
        items,
        list: response.results.map(library => library.id),
      }
    },

    [CLIENT_LIBRARY_DISCOVERY_PANEL_RECENT_LOAD_FAIL](
      state: State,
      { error }: Record<string, any>,
    ) {
      return { ...state, error, loading: false }
    },
  },
)
